export default __webpack_public_path__ + "static/media/faq.1c66db8f.jpeg";